var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.map.type,"icon":_vm.map.icon},on:{"click":_vm.map.click}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.map.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }